import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { handleLogout } from '../utils/loginFunctions';
import { setAllowedParts } from '../actions/accessToParts';

/**
 * Renders a button which, when selected, will redirect the page to the logout prompt
 */
export function SignOutButton() {
  const { instance } = useMsal();
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const logoutTNEHandler = () => {
    dispatch(
      setAllowedParts({
        onboarding: false,
        tAndEContractor: false,
        tAndEApprover: false
      })
    );
  };

  return (
    <button
      className="ml-auto"
      onClick={async () => {
        logoutTNEHandler();
        await handleLogout(instance);
        window.history.replaceState({}, document.title, window.location.pathname);
      }}
    >
      {t('common.header.menu.logout')}
    </button>
  );
}
